var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShowPasswordIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5799 12.5C15.5799 14.48 13.9799 16.08 11.9999 16.08C10.0199 16.08 8.41992 14.48 8.41992 12.5C8.41992 10.52 10.0199 8.91998 11.9999 8.91998C13.9799 8.91998 15.5799 10.52 15.5799 12.5Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 20.77C15.5298 20.77 18.8198 18.69 21.1098 15.09C22.0098 13.68 22.0098 11.31 21.1098 9.89997C18.8198 6.29997 15.5298 4.21997 11.9998 4.21997C8.46984 4.21997 5.17984 6.29997 2.88984 9.89997C1.98984 11.31 1.98984 13.68 2.88984 15.09C5.17984 18.69 8.46984 20.77 11.9998 20.77Z",
    stroke: "#7E8299",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShowPasswordIcon);
export default __webpack_public_path__ + "static/media/show-password-icon.72219e34175fafbc4797bc64a5b04e12.svg";
export { ForwardRef as ReactComponent };